import React, { useState, useCallback } from "react";
import { Routes, Route } from "react-router-dom";
import Accueil         from "./components/pages/Accueil";
import MentionsLegales from "./components/pages/Mentions_legales";
import Header      from "./components/Header";
import Footer      from "./components/Footer";
import SplashScreen from "./components/SplashScreen";

import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

/*
  États du splash :
  • 'show'   — splash visible, site masqué
  • 'fading' — splash en train de disparaître (transition CSS)
  • 'done'   — splash retiré du DOM, site visible
*/
const SPLASH_KEY = "slimetech-splash-shown";

function App() {
  const alreadySeen = localStorage.getItem(SPLASH_KEY);

  const [splashState, setSplashState] = useState(
    alreadySeen ? "done" : "show"
  );

  const handleSplashComplete = useCallback(() => {
    setSplashState("fading");
    setTimeout(() => {
      setSplashState("done");
      localStorage.setItem(SPLASH_KEY, "1");
    }, 900); // durée = transition CSS opacity dans SplashScreen.css
  }, []);

  return (
    <div className="App">
      {/* Splash screen — affiché une fois par session */}
      {splashState !== "done" && (
        <SplashScreen
          fading={splashState === "fading"}
          onComplete={handleSplashComplete}
        />
      )}

      {/* Site principal */}
      <Header />
      <Routes>
        <Route path="/"                 element={<Accueil />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/Mentions_legales" element={<MentionsLegales />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
